<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [url]="url"
  [columns]="columns"
  [filters]="filters"
  [columnWidths]="columnWidths"
  [type]="'dermaiList'"
  [signalModel]="signalrModel"
></app-tables>